import axios, { AxiosResponse } from 'axios';
import { API_BASE_URL } from 'src/helper/constants';
import { apiCatchHandler } from 'src/helper/utils';
import { IGenerateOTPResponse } from '../login/login-component/login-component-types';
import { initialValidOTPDetail, IValidateOTPResponse, IValidOTPDetail } from './third-party-login-component-types';
import { AUVerificationStatusResponse } from 'src/modules/common/common-types';
import { LogoutCause } from '../axios-interceptor';

export function generateOTPForAU(
	companyId: number,
	auClientGuid: string,
	callback: (generateOTPResponse: IGenerateOTPResponse) => void,
) {
	const generateOTPResponse: IGenerateOTPResponse = {
		error: false,
	};
	axios
		.get(`${API_BASE_URL}/api/third-party/otp/generate/${auClientGuid}/${companyId}`, {
			withCredentials: true,
		})
		.then((response: AxiosResponse) => {
			generateOTPResponse.error = false;
			callback(generateOTPResponse);
		})
		.catch((error) => {
			generateOTPResponse.error = true;
			apiCatchHandler(error, generateOTPResponse, callback);
		});
}

export function validateOTPForAURegistration(
	companyId: number,
	otp: string,
	auClientGuid: string,
	callback: (validateOTPResponse: IValidateOTPResponse) => void,
) {
	const validateOTPResponse: IValidateOTPResponse = {
		validOTPDetail: initialValidOTPDetail,
		error: false,
	};
	axios
		.post(`${API_BASE_URL}/api/third-party/otp/registration/validate/${auClientGuid}/${companyId}?otp=${otp}`, '', {
			withCredentials: true,
		})
		.then((response: AxiosResponse<IValidOTPDetail>) => {
			const { data } = response;
			validateOTPResponse.validOTPDetail = data;
			callback(validateOTPResponse);
		})
		.catch((error) => {
			validateOTPResponse.error = true;
			apiCatchHandler(error, validateOTPResponse, callback);
		});
}

export function validateOTPForAULogin(
	companyId: number,
	otp: string,
	auClientGuid: string,
	callback: (validateOTPResponse: IValidateOTPResponse) => void,
) {
	const validateOTPResponse: IValidateOTPResponse = {
		validOTPDetail: initialValidOTPDetail,
		error: false,
	};
	axios
		.post(`${API_BASE_URL}/api/third-party/otp/login/validate/${auClientGuid}/${companyId}?otp=${otp}`, '', {
			withCredentials: true,
		})
		.then((response: AxiosResponse<IValidOTPDetail>) => {
			const { data } = response;
			validateOTPResponse.validOTPDetail = data;
			callback(validateOTPResponse);
		})
		.catch((error) => {
			validateOTPResponse.error = true;
			apiCatchHandler(error, validateOTPResponse, callback);
		});
}

export function isThirdPartyUserVerified(
	companyId: number,
	auClientGuid: string,
	callback: (auRegistrationStatus: AUVerificationStatusResponse) => void,
) {
	axios
		.get(`${API_BASE_URL}/api/third-party/is-verified/${auClientGuid}/${companyId}`, {
			withCredentials: true,
		})
		.then((response: AxiosResponse<AUVerificationStatusResponse>) => {
			const data = response.data;
			callback(data as AUVerificationStatusResponse);
		})
		.catch((error) => {
			apiCatchHandler(error, false, callback);
		});
}

export function isAccessLinkExpired(companyId: number, auClientGuid: string, callback: () => void) {
	axios
		.get(`${API_BASE_URL}/api/third-party/is-access-link-expired/${auClientGuid}/${companyId}`, {
			withCredentials: true,
		})
		.then((response: AxiosResponse<boolean>) => {
			const data = response.data;
			callback();
		})
		.catch((error) => {
			apiCatchHandler(error, false, callback);
		});
}

export const getThirdPartyActiveSessionTimeout = (
	auRegistrationId: number,
	callback: (sessionTimeout: number) => void,
) => {
	axios
		.get(`${API_BASE_URL}/api/helper/third-party-active-session-timeout/${auRegistrationId}`, {
			withCredentials: true,
		})
		.then((response) => {
			callback(response.data);
		})
		.catch((error) => {
			apiCatchHandler(error, false, callback);
		});
};

export const getLogoutCause = (
	companyId: number,
	auRegistrationId: number,
	callback: (logoutCause: LogoutCause) => void,
) => {
	axios
		.get(`${API_BASE_URL}/api/third-party/get-logout-cause/${auRegistrationId}/${companyId}`, {
			withCredentials: true,
			headers: {
				'Content-Type': 'application/json',
			},
		})
		.then((response) => {
			callback(response.data);
		})
		.catch((error) => {
			console.error('Error fetching logout cause:', error);
			apiCatchHandler(error, false, callback);
		});
};
